const currentAnnee = (state) => Math.max.apply(Math, state.dossier.annees.map((annee) => annee.annee));
const currentTarifs = (state) => state.tarifs.filter((tarif) => currentAnnee(state) === tarif.annee_application.annee);
const currentOptions = (state) => state.options.filter((option) => currentAnnee(state) === option.annee_application.annee);

export default {
    getCollectiviteName: (state) => {
        if (state.collectivite.type_collectivite && 'epci' === state.collectivite.type_collectivite.code && state.collectivite.epci) {
            return `${state.collectivite.epci.nature_epci ? state.collectivite.epci.nature_epci.libelle : ''} ${state.collectivite.epci.nom}`;
        } else if (state.collectivite.commune) {
            return state.collectivite.commune.nom;
        }

        return '';
    },
    getCurrentAnnee: currentAnnee,
    getCurrentTarifs: currentTarifs,
    getCurrentOptions: currentOptions,
    getCurrentTarif: (state) => (id) => currentTarifs(state).find((tarif) => tarif.tarif_id === id),
    getCurrentOption: (state) => (id) => currentOptions(state).find((option) => option.option_calcul_taxe_id === id),
};



// WEBPACK FOOTER //
// ./src/store/modules/Collectivite/getters.js